<template>
  <body class="login-body">
    <div class="login-card">
      <div class="login-content">
        <div style="padding-bottom: 10px">
          <img
            width="25%"
            src="../../public/assets/layout/images/pmg-shops.png"
          />
          <img
            width="75%"
            style="padding-bottom: 15px"
            src="../../public/assets/layout/images/pmg-logo.png"
          />
        </div>

        <div class="username-container">
          <label>ข้อมูลผู้ใช้งาน</label>
          <div class="login-input">
            <InputText
              v-model="username"
              placeholder="กรอกข้อมูลผู้ใช้งาน"
              required="true"
              autofocus
              :class="{
                'p-invalid': error_login_username,
              }"
            />
            <small class="p-invalid" v-if="error_login_username">{{
              $t("error_login_username")
            }}</small>
          </div>
        </div>
        <div class="password-container">
          <label>รหัสผ่าน</label>
          <div class="login-input">
            <InputText
              v-model="password"
              type="password"
              placeholder="กรอกรหัสผ่าน"
              required="true"
              :class="{
                'p-invalid': error_login_password,
              }"
            />
            <small class="p-invalid" v-if="error_login_password">{{
              $t("error_login_password")
            }}</small>
          </div>
        </div>
        <div>
          <Button class=".p-button" label="เข้าระบบ" @click="goDashboard" />
        </div>
        <center>
          <p class="pointer" @click="goPolicy">นโยบายความเป็นส่วนตัว</p>
        </center>
      </div>
    </div>
  </body>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      error_login_username: false,
      error_login_password: false,
    };
  },
  methods: {
    goDashboard() {
      this.error_login_username = false;
      this.error_login_password = false;

      if (this.username == "" && this.password == "") {
        this.error_login_username = true;
        this.error_login_password = true;
      } else {
        if (
          (this.username == "Bombel2man" && this.password == "12345") ||
          (this.username == "Administrator" && this.password == "12345")
        ) {
          localStorage.setItem("userSession", this.username);
          window.location = "/map-disaster";
        } else {
          this.error_login_username = true;
          this.error_login_password = true;
        }
      }
    },
    goPolicy() {
      window.location = "/policy";
    },
  },
};
</script>

<style scoped>
.login-body {
  background-image: url("../../public/assets/layout/images/layout/hike-in-patagonia.jpg");
  background-color: white;
}

.login-body .login-card .login-content button {
    width: 100%;
    margin-bottom: 10px;
}

.p-button {
  background-color: #21529f;
  border-color: whitesmoke;
  color: white;
}
.p-button:hover {
  background-color: orange;
  border-color: black;
  color: white;
}

.forgetpassword-container {
  color: black;
}
</style>